module.exports = __webpack_public_path__ + "static/UnclickTravelInconvenience-d45fe93994af57cffc2a7b3dda16efd3.png";